<div class="main" [formGroup]="formGroup" [style.width.px]="dialogWidth$ | async"
    [style.left.px]="dialogLeftPosition$ | async">
    <div class="message">{{ dialogService.message$ | async }}</div>

    <div class="comment-section">
        <textarea class="comment" placeholder="enter a comment" formControlName="comment"></textarea>
    </div>
    <div class="actions">
        <div class="button right" [ngClass]="{'disabled': this.formGroup.invalid}" (click)="submitResponse()">continue
        </div>
        <div (click)="cancel()" class="button">cancel</div>
    </div>
</div>